import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const customerServiceCustomersRoute: InvariantJiraRoute = {
	name: 'customer-service-customers',
	path: '/jira/customer-service/customers',
	exact: true,
};
